import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Search, Loader2 } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { SearchResults, countItems } from '../components/search/SearchResults';
import { useSiteSearch, keyNav } from '../components/search/useSiteSearch';
import { hasResults } from '../lib/siteSearch';

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const s = useSiteSearch(params.get('q') || '');
  const box = useRef(null);
  useEffect(() => { const t = setTimeout(() => setParams(s.q ? { q: s.q } : {}, { replace: true }), 400); return () => clearTimeout(t); }, [s.q]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-20 max-w-3xl mx-auto px-4" data-testid="search-page">
        <h1 className="text-3xl sm:text-4xl text-neutral-900 mb-6">Search</h1>
        <label className="relative block mb-6">
          <Search className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-neutral-400" />
          <input autoFocus value={s.q} onChange={(e) => s.setQ(e.target.value)} onKeyDown={keyNav(s, countItems(s.r), box)} aria-label="Search the site"
            placeholder="Search products, fabrics, colors, guides…" className="w-full pl-12 pr-10 py-3.5 rounded-xl border border-neutral-300 text-base focus:outline-none focus:border-amber-500" data-testid="search-page-input" />
          {s.loading && <Loader2 className="w-4 h-4 animate-spin text-neutral-400 absolute right-4 top-1/2 -translate-y-1/2" />}
        </label>
        <div ref={box}>
          {s.r && hasResults(s.r) && <SearchResults r={s.r} active={s.active} />}
          {s.r && !hasResults(s.r) && <p className="py-10 text-center text-neutral-500" data-testid="search-page-empty">No results for “{s.q}”. Try a product, color or collection name.</p>}
        </div>
      </main>
      <Footer />
    </div>
  );
}
